import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnButtonGroup as UICnButtonGroup } from './cn-button-group';
const CnButtonGroup = withI18n(UICnButtonGroup, {
    locale,
    _noHoc: true,
});
export { CnButtonGroup };
